import {Component, ViewChild} from '@angular/core';
import {Nav, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {Storage} from '@ionic/storage';
import {Broadcaster} from './broadcaster';
import {Localization} from '../app/app.localization';

//import { RecommendPage } from '../pages/recommend/recommend';
//import { ListPage } from '../pages/list/list';
import {LoginPage} from '../pages/login/login';
import {ApiService} from '../app/services/api.service';
import {Config} from '../app/app.config';

import {TabsPage} from '../pages/tabs/tabs';
import {LoadingPage} from '../pages/loading/loading';
import {OrderHistoryPage} from '../pages/order-history/order-history';
import {ErrorPage} from '../pages/error/error';
import {PurchasePage} from '../pages/purchase/purchase';
import {Router, RouteInfo} from '../components/Router';
import {OrderStopPage} from '../pages/order-stop/order-stop';
import { Response, Http, Headers, RequestOptions } from '@angular/http';
import { OkageGoGoogleAnalyticsProvider } from '../providers/okage-go-google-analytics/okage-go-google-analytics';
import { StyleLoaderProvider } from '../providers/style-loader/style-loader';
import { ModalController } from 'ionic-angular';
import { SelectReceiveModalComponent } from '../components/select-receive-modal/select-receive-modal';
import { OkageStorageProvider } from '../providers/okage-storage/okage-storage'
import { CommercePage } from '../pages/commerce/commerce';

@Component({
  templateUrl: 'app.html',
  providers: [ApiService]
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  //rootPage: any = RecommendPage;
  // rootPage:any = TabsPage;
  rootPage: any;
  //rootPage:any = LoginPage;
  settings: any;

  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private _loc:Localization,
    private storage: Storage,
    private broadcaster: Broadcaster,
    private router: Router,
    private _styleLoader: StyleLoaderProvider,
    private _http: Http,
    private _ga: OkageGoGoogleAnalyticsProvider,
    private _apiService: ApiService,
    private _okageStorage: OkageStorageProvider,
    public modalCtrl: ModalController) {

    // ブラウザバックで強制リロード
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };

    this.storage.clear();
    localStorage.setItem("foods.submenu", "");
    localStorage.setItem("menuGroup.mst", "");

    localStorage.setItem("testval", "test");

    // result=stop以外のを注文後の戻り先と設定する
    if(this.getUrlParameter("result") != "stop" && this.getUrlParameter("canceled") != "1") {
      localStorage.setItem("redirect_url", encodeURIComponent(document.location.href));
    }

    // 店内のクレジットカード支払い中断時
    if(!Config.build_as_takeout && (this.getUrlParameter("result") == "stop" || this.getUrlParameter("canceled") == "1")) {
      localStorage.setItem("stopPaymentByInStore", "1");
    } else {
      localStorage.setItem("stopPaymentByInStore", "0");
    }
    console.log("test val is:" + localStorage.getItem("testval"));

    let routeInfo:RouteInfo = null;
    if (Config.build_as_takeout){
      routeInfo = router.routeMobile(Config);
    }else if(Config.deferred){
      routeInfo = router.routeInStoreDeferred(Config);
    }else{
      routeInfo = router.routeInStore(Config);
    }
    console.log(routeInfo);

    let commerce = this.getUrlParameter("commerce");
    if (commerce === '1') {
      this.rootPage = CommercePage;
      return;
    }

    if (routeInfo){
      if (routeInfo.routeType == "redirect"){
        // refererを保持する
        localStorage.setItem("referrer", document.referrer);
        window.document.location.href = routeInfo.routeTarget;
      }
      if (routeInfo.routeType == "page"){
        this.rootPage = routeInfo.routeTarget;
      }
      return;
    }


    let client_cd = localStorage.getItem("client_cd");
    let store_id = localStorage.getItem("store_id");
    _ga.setBasePath(`/${client_cd}/${store_id}`);

    /** okage tracking id */
    if (Config.okage_tracking_id && Config.okage_tracking_id.length > 0){
      _ga.addTrackingId(Config.okage_tracking_id, 'okage');
    }

    var language = (window.navigator["userLanguage"] || window.navigator["language"] || window.navigator["browserLanguage"]);
    var local_loc = localStorage.getItem("loc");
    if (local_loc && local_loc.length > 0){
      language = local_loc;
    }
    _loc.setLoc(document.getElementById("accept_language").getAttribute("lang"));
    _loc.setLoc(language);

    // register subscribe for purchase request
    this.broadcaster.on<number>('request.purchase')
      .subscribe(state => {
        console.log("receive purchase");
        this.rootPage = PurchasePage;
      });

    let debugEnable = (localStorage.getItem("debug") && parseInt(localStorage.getItem("debug")+"", 0) > 0);
    let configs = [
      'TSO_USE_SINGLEORDERFLOW',
      'MOBILEORDER_NOUSE_ADDRESS',
      'MOBILEORDER_COMPLETE_MESSAGE',
      'MOBILEORDER_COMPLETE_VIEW_REDIRECT_BUTTON',
      'MOBILEORDER_COMPLETE_VIEW_REDIRECT_BUTTON_NAME',
      'MOBILEORDER_LEAD_TIME_MIN',
      'OKAGEGO_CURRENT_WAIT_MINUTES',
      'MOBILEORDER_INTERVAL_TIME_MIN',
      'MOBILEORDER_LIMIT_TIME_HOUR',
      'MOBILEORDER_LIMIT_TIME_MIN',
      'MOBILEORDER_ENABLE_EMAIL',
      'MOBILEORDER_ENABLE_SMS',
      'MOBILEORDER_ENABLE_RECEIVE_TIME',
      'MOBILEORDER_PAYMENT_MODULE',
      'MOBILEORDER_FIXED_LAYOUT',
      'INSTORESELF_SELFPAY_URL',
      'MOBILEORDER_RECEIVE_TIMERULE',
      'MOBILEORDER_ENABLE_NOTIFY_AFTER_ORDERING',
      'OKAGEGO_DELIVERY_WAIT_MINUTES',
      'MOBILEORDER_RECEIVE_METHOD',
      'MOBILEORDER_DELIVERY_RECEIVE_TIMERULE',
      'MOBILEORDER_DELIVERY_LEAD_TIME_MIN',
      'MOBILEORDER_DELIVERY_INTERVAL_TIME_MIN',
      'MOBILEORDER_DELIVERY_LIMIT_TIME_HOUR',
      'MOBILEORDER_DELIVERY_LIMIT_TIME_MIN',
      'MOBILEORDER_DELIVERY_CHARGE',
      'MOBILEORDER_DELIVERY_CHARGE_MENU_ID',
      'MOBILEORDER_DELIVERY_AREA_TEXT',
      'MOBILEORDER_DELIVERY_AREA_POST_CODE',
      'MOBILEORDER_DELIVERY_AREA_POST_CODE_INFO',
      'MOBILEORDER_FIXED_LAYOUT_ADDITIONAL_CSS',
      'MOBILEORDER_FIXED_LAYOUT_ADDITIONAL_STYLE',
      'MOBILEORDER_FIXED_LAYOUT_BACKGROUND_IMAGE',
      'MOBILEORDER_FIXED_LAYOUT_BACKGROUND_COLOR',
      'MOBILEORDER_OPEN_AT',
      'MOBILEORDER_OPEN_AT_MIN',
      'MOBILEORDER_REQUIRED_MENU_LIST',
      'MOBILEORDER_RESEND_MAIL_GUIDE',
      'MOBILEORDER_USER_INFO_TYPE',
      'INSTORE_PAYMENT_DISABLE_URL',
      'INSTORE_PAYMENT_ALERT_MESSAGE',
      'SPECIFIED_COMMERCIAL_TRANSACTION_HTML',
      'MOBILEORDER_ANALYTICS_TRACKER_ID',
      "MOBILEORDER_CUSTOM_THANKS_VIEW_URL", //  order-history 注文完了ページで表示するカスタムiframeのURL
      'MOBILEORDER_REMARKS_BY_STORE',
      'MOBILEORDER_IGNORE_POPUP_ACCESS_EXTERNAL_SITE',
      'MOBILEORDER_DUPLICATE_ORDER_CHECK',
      'MOBILEORDER_RESEND_MAIL_TAB',
    ];
    this._apiService.getSettings().subscribe(
      (settings) => {
        this.settings = settings;
        if (!debugEnable && (localStorage.getItem("reserved") != "1")) {
          if (!this.checkMobileOrderOpenStatus()) return;
        }

        this._apiService.getConfigs(configs).subscribe(
          (result) => {
            localStorage.setItem('configs', JSON.stringify(result.result));

            console.log(result.result);
            if (result.result["MOBILEORDER_FIXED_LAYOUT_ADDITIONAL_CSS"]){
              let cssfiles = JSON.parse(result.result["MOBILEORDER_FIXED_LAYOUT_ADDITIONAL_CSS"]);
              for(let cssfile of cssfiles){
                _styleLoader.loadCssFile(cssfile);
              }
            }
            if (result.result["MOBILEORDER_FIXED_LAYOUT_ADDITIONAL_STYLE"]){
              _styleLoader.writeStyles(result.result["MOBILEORDER_FIXED_LAYOUT_ADDITIONAL_STYLE"]);
            }
            if (result.result["MOBILEORDER_ANALYTICS_TRACKER_ID"]
            && result.result["MOBILEORDER_ANALYTICS_TRACKER_ID"].length > 0 )
            {
              this._ga.addTrackingId(result.result["MOBILEORDER_ANALYTICS_TRACKER_ID"], "client", true);
            }
            const enableNotification = result.result["MOBILEORDER_ENABLE_NOTIFY_AFTER_ORDERING"];
            if (Config.build_as_takeout){
              // mobile
              if(localStorage.getItem("visitor_id")){
                this.rootPage = OrderHistoryPage;
                let sendType = '';
                if(localStorage.getItem('receiveMethod') === 'delivery') {
                  sendType = 'mobileorder_completed_delivery';
                } else {
                  sendType = 'completed_okagego_order';
                }
                // メール送信
                if(this.getUrlParameter("paid") == "success" && enableNotification == 1){
                  if (localStorage.getItem("reserved") == "1") {
                    let menubook_id = localStorage.getItem("menubook_id");
                    sendType = 'completed_okagego_reserved_'+menubook_id;
                    this._apiService.sendReservedMessage(localStorage.getItem("store_id"), localStorage.getItem("visitor_id"), sendType).subscribe(
                      (result) => {
                        console.log(result);
                        if (!result.status || parseInt(result.status, 0) !== 1000) {
                          console.log('通知メッセージ送信に失敗しました');
                        }
                      }
                    );
                  } else {
                    this._apiService.sendMessage(localStorage.getItem("store_id"), localStorage.getItem("visitor_id"), sendType).subscribe(
                      (result) => {
                        console.log(result);
                        if (!result.status || parseInt(result.status, 0) !== 1000) {
                          console.log('通知メッセージ送信に失敗しました');
                        }
                      }
                    );
                  }
                }
                return;
              }
              this.prepareData();
              this.selectReceiveModal(result.result);
            }else{
              // instore
              if (Config.deferred){
                // instore deferred
                this.prepareData();
                localStorage.setItem("receiveMethod", 'takeout');
                return;
              }

              this._apiService.checkVisitor().subscribe(
                (result) => {
                  if (Config.build_as_takeout || (result.status && parseInt(result.status) == 1000)) {
                    if (result.payments && result.payments.length > 0){
                      this.rootPage = PurchasePage;
                      return;
                    }
                    this.prepareData();
                  } else {
                    this.rootPage = ErrorPage;
                  }
                }
              );
            }
          }
        );
      }
    );
    this._apiService.getStores().subscribe(
      (result) => {
        localStorage.setItem('storeName', result.result['store_name']);
      }
    );

    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      {title: 'よくある質問', component: null},
      {title: 'お問い合わせ', component: null},
      {title: 'ご利用規約', component: null}
    ];

  }
  // OkageGoの利用可能状況確認。true:利用可能 / false:利用不可
  checkMobileOrderOpenStatus() {
    if (Config.build_as_takeout
      && this.settings
      && this.settings.outoftime
      && (!localStorage.getItem("visitor_id"))
      && (localStorage.getItem("reserved") != "1"))
      {
      // 営業時間外 selforder管理画面の基本設定で設定した開店時間、閉店時間外だった場合
      localStorage.setItem("open_status", "4");
      localStorage.setItem("closed_time_message", this.settings.result.closed_time_message);
      this.rootPage = OrderStopPage;
      return false;
    }
    else if (Config.build_as_takeout
      && this.settings
      && this.settings.result
      && this.settings.result.open_status
      && parseInt(this.settings.result.open_status, 0) != 1
      && (!localStorage.getItem("visitor_id"))
      && (localStorage.getItem("reserved") != "1"))
      {
      // ハンディのモバイルオーダー設定で開店以外に設定している場合 (一時停止、閉店)
      localStorage.setItem("open_status", this.settings.result.open_status);
      localStorage.setItem("close_message", this.settings.result.close_message);
      localStorage.setItem("pause_message", this.settings.result.pause_message);
      this.rootPage = OrderStopPage;
      return false;
    }
    return true;
  }

  prepareData(){  // send Top page
    this._ga.topPageView(localStorage.getItem("referrer"));
    this.rootPage = LoadingPage;
    this.broadcaster.broadcast('loading.debug', "Start Loading");
    this.storage.get("menulayouts").then((f) => {
      if (!f) {
        let inside = (Config.build_as_takeout) ? false : true;
        this._apiService.getMenulayouts(inside).subscribe(
          (result) => {
            this.broadcaster.broadcast('loading.debug', "Menulayout Loaded");
            if (typeof result.result !== 'undefined') {
              if(result.result.length > 0){
                localStorage.setItem("menubook_id", result.result[0].menubook_id);
                this.storage.set('menulayouts', result.result).then(() => {
                  if (typeof result.urls !== 'undefined') {
                    this.storage.set('urls', result.urls).then(() => {

                    });
                  }
                });
                // 予約日の取得
                this._okageStorage.setItem("reserved_settings", "");
                this._okageStorage.setItem("reserved_dates", "");
                if (result.result[0].reserved_settings && result.result[0].reserved_settings.reserved_disabled == "0") {
                  var r_settings = result.result[0].reserved_settings;
                  var r_dates = [];
                  // 予約時間帯を計算
                  var r_interval_time = (r_settings.interval_time) ? Number(r_settings.interval_time) : 15;
                  var r_enable_time = [];
                  var now = new Date();
                  var r_open_date = new Date(r_settings.reserved_open_date.substring(0,4), r_settings.reserved_open_date.substring(5,7)-1, r_settings.reserved_open_date.substring(8,10), 0, 0)
                  var r_close_date = new Date(r_settings.reserved_close_date.substring(0,4), r_settings.reserved_close_date.substring(5,7)-1, r_settings.reserved_close_date.substring(8,10), 23, 59, 59)
                  if (r_open_date < now && now < r_close_date) {
                    var r_from_time = new Date(now.getFullYear(), now.getMonth(), now.getDate(), r_settings.reserved_from_time.substr(0,2), r_settings.reserved_from_time.substr(3,2));
                    var r_to_time = new Date(now.getFullYear(), now.getMonth(), now.getDate(), r_settings.reserved_to_time.substr(0,2), r_settings.reserved_to_time.substr(3,2));
                    while (r_from_time.getTime() <= r_to_time.getTime()) {
                      r_enable_time.push({
                        hour: (("0") + r_from_time.getHours()).substr(-2),
                        min: (("0") + r_from_time.getMinutes()).substr(-2)
                      });
                      r_from_time = new Date(r_from_time.getFullYear(), r_from_time.getMonth(), r_from_time.getDate(), r_from_time.getHours(), r_from_time.getMinutes() + r_interval_time);
                    }

                    // 予約日の詳細設定を使わない場合
                    if (r_settings.use_detail_rule == "0") {
                      var r_from_date = new Date(r_settings.reserved_from_date);
                      var r_to_date = new Date(r_settings.reserved_to_date);
                      while (r_from_date <= r_to_date) {
                        r_dates.push({
                          date: new Date(r_from_date),
                          time: r_enable_time,
                        });
                        r_from_date.setDate(r_from_date.getDate() + 1);
                      }
                    } else if (r_settings.use_detail_rule == "1" && result.result[0].reserved_dates) { // 予約日詳細設定（日付）を使う場合
                      var reserved_date = result.result[0].reserved_dates;
                      reserved_date.sort((a, b) => {
                        if (new Date(a.reserved_date) < new Date(b.reserved_date)) return -1;
                        if (new Date(a.reserved_date) > new Date(b.reserved_date)) return 1;
                        return 0;
                      });
                      reserved_date.forEach(r_date => {
                        if (r_date.reserved_disabled == "0" || r_date.delete_flag == "1") {
                          r_dates.push({
                            date: new Date(r_date.reserved_date),
                            time: (r_date.reserved_time) ? JSON.parse(r_date.reserved_time) : r_enable_time
                          });
                        }
                      });
                    }
                    // 予約日
                    this._okageStorage.setItem("reserved_settings", r_settings);
                    this._okageStorage.setItem("reserved_dates", r_dates);
                    localStorage.setItem("reserved", "1");
                  } else {
                    localStorage.setItem("open_status", "5");
                    if (r_open_date > now) localStorage.setItem("reserved_stop_message", (r_settings.reserved_before_start_message && r_settings.reserved_before_start_message.length > 0) ? r_settings.reserved_before_start_message : "予約の受付は["+r_settings.reserved_open_date+"]\nから開始になります。");
                    if (now > r_close_date) localStorage.setItem("reserved_stop_message", (r_settings.reserved_after_end_message && r_settings.reserved_after_end_message.length > 0) ? r_settings.reserved_after_end_message : "予約の受付は終了いたしました。");
                    this.rootPage = OrderStopPage;
                    return;
                  }
                } else {
                  let debugEnable = (localStorage.getItem("debug") && parseInt(localStorage.getItem("debug")+"", 0) > 0);
                  if (!debugEnable) {
                    if (!this.checkMobileOrderOpenStatus()) return;
                  }
                }
              }
              let mfoods: any = [];
              let sfoods: any = {};
              mfoods[0] = [];
              mfoods[1] = [];
              mfoods[2] = [];
              this.broadcaster.broadcast('loading.debug', "Menu to load");
              this._apiService.getMenuList(this._loc.loc).subscribe(
                (result) => {
                  this.broadcaster.broadcast('loading.debug', "Menu Loaded");
                  let mgroup = [];
                  if (typeof result.result !== 'undefined') {
                    this.storage.set('menu.list', result);
                    for (var i = 0; i < result.result.length; i++) {
                      // ignore menu group
                      if (result.result[i].menuClasse.menu_classe == 20) {
                        continue;
                      }
                      let mnamei: string = result.result[i].menu_name;
                      if (typeof result.result[i].menu_full_name !== 'undefined' && result.result[i].menu_full_name.length > 0) {
                        mnamei = result.result[i].menu_full_name;
                      }

                      let tmpitem: any = {
                        id: result.result[i].menu_id,
                        title: mnamei,
                        is_rock: result.result[i].is_rock,
                        is_soldout_rock: result.result[i].is_soldout_rock,
                        is_wait_arrival_rock: result.result[i].is_wait_arrival_rock,
                        desc: result.result[i].menu_desc,
                        thumb: result.result[i].menu_image,
                        price: result.result[i].price,
                        notax_price: result.result[i].notax_price,
                        like: (result.result[i].likes ? result.result[i].likes : 0),
                        liked: false,
                        menu_classification_id: result.result[i].menu_classification_id,
                        category_id: result.result[i].category_id,
                        category_name: result.result[i].category_name,
                        category_sort_order: result.result[i].category_sort_order,
                        menu_sort_order: result.result[i].menu_sort_order,
                        allergy: (result.result[i].allergy) ? result.result[i].allergy : [],
                        menu_limit_in_order: result.result[i].menu_limit_in_order,
                      }

                      // additional menu
                      if (result.result[i].menuClasse.menu_classe == 50) {
                        if (typeof result.result[i].menu_parent_id !== 'undefined') {
                          // parent of additional menu (group menu)
                          for (var gi = 0; gi < result.result[i].menu_parent_id.length; gi++) {
                            // search for group menu
                            for (var j = 0; j < result.result.length; j++) {

                              let mnamej: string = result.result[j].menu_name;
                              let midj = result.result[j].menu_id;
                              if (typeof result.result[j].menu_full_name !== 'undefined' && result.result[j].menu_full_name.length > 0) {
                                mnamej = result.result[j].menu_full_name;
                              }
                              // found group menu
                              if (result.result[j].menu_id == result.result[i].menu_parent_id[gi]) {
                                if (typeof result.result[j].menu_parent_id !== 'undefined') {
                                  // parent of group menu (deployment menu or else)
                                  for (var di = 0; di < result.result[j].menu_parent_id.length; di++) {
                                    // search for deployment menu
                                    for (var k = 0; k < result.result.length; k++) {
                                      // found deployment menu
                                      if (result.result[k].menu_id == result.result[j].menu_parent_id[di]) {
                                        tmpitem['parent'] = result.result[k].menu_id;
                                        if (!sfoods[result.result[k].menu_id]) {
                                          sfoods[result.result[k].menu_id] = [];
                                        }

                                        sfoods[result.result[k].menu_id].push({
                                          id: result.result[i].menu_id,
                                          parent: result.result[k].menu_id,
                                          title: mnamei,
                                          is_rock: result.result[i].is_rock,
                                          is_soldout_rock: result.result[i].is_soldout_rock,
                                          is_wait_arrival_rock: result.result[i].is_wait_arrival_rock,
                                          group_name: mnamej,
                                          group_id: midj,
                                          desc: result.result[i].menu_desc,
                                          thumb: result.result[i].menu_image,
                                          price: (typeof result.result[i].price == 'undefined' ? 0 : result.result[i].price),
                                          notax_price: (typeof result.result[i].notax_price == 'undefined' ? 0 : result.result[i].notax_price),
                                          as_topping: result.result[i].as_topping,
                                          quantity: 0,
                                          // required_flag of group menu
                                          required: (parseInt(result.result[j].required_flag) ? true : false),
                                          like: (result.result[i].likes ? result.result[i].likes : 0),
                                          liked: false,
                                          menu_classification_id: result.result[i].menu_classification_id,
                                          category_id: result.result[i].category_id,
                                          category_name: result.result[i].category_name,
                                          category_sort_order: result.result[i].category_sort_order,
                                          menu_sort_order: result.result[i].menu_sort_order,
                                          menu_limit_in_order: result.result[i].menu_limit_in_order,
                                        });

                                        break;
                                      }
                                    }
                                  }
                                }
                                break;
                              }
                            }
                          }
                        }
                      }

                      // expand menu
                      if (result.result[i].menuClasse.menu_classe == 10) {
                        if (typeof result.result[i].menu_parent_id !== 'undefined') {
                          // parent of expand menu (deployment menu)
                          for (var gi = 0; gi < result.result[i].menu_parent_id.length; gi++) {
                            // search for deployment menu
                            for (var k = 0; k < result.result.length; k++) {
                              // found deployment menu
                              if (result.result[k].menu_id == result.result[i].menu_parent_id[gi]) {
                                tmpitem['parent'] = result.result[k].menu_id;
                                if (!sfoods[result.result[k].menu_id]) {
                                  sfoods[result.result[k].menu_id] = [];
                                }
                                if (parseInt(result.result[i].required_flag) == 0) {
                                  sfoods[result.result[k].menu_id].push({
                                    id: result.result[i].menu_id,
                                    parent: result.result[k].menu_id,
                                    title: mnamei,
                                    is_rock: result.result[i].is_rock,
                                    is_soldout_rock: result.result[i].is_soldout_rock,
                                    is_wait_arrival_rock: result.result[i].is_wait_arrival_rock,
                                    desc: result.result[i].menu_desc,
                                    thumb: result.result[i].menu_image,
                                    price: (typeof result.result[i].price == 'undefined' ? 0 : result.result[i].price),
                                    notax_price: (typeof result.result[i].notax_price == 'undefined' ? 0 : result.result[i].notax_price),
                                    as_topping: result.result[i].as_topping,
                                    quantity: 0,
                                    // required_flag of expand menu
                                    required: (parseInt(result.result[i].required_flag) ? true : false),
                                    like: (result.result[i].likes ? result.result[i].likes : 0),
                                    liked: false,
                                    menu_classification_id: result.result[i].menu_classification_id,
                                    category_id: result.result[i].category_id,
                                    category_name: result.result[i].category_name,
                                    category_sort_order: result.result[i].category_sort_order,
                                    menu_sort_order: result.result[i].menu_sort_order,
                                    menu_limit_in_order: result.result[i].menu_limit_in_order,
                                  });
                                }

                                break;
                              }
                            }
                          }
                        }
                      }

                      // food
                      if (result.result[i].category_type_id == Config.category.food) {
                        if (!mfoods[0]) {
                          mfoods[0] = [];
                        }
                        mfoods[0].push(tmpitem);
                      }
                      //drink
                      else if (result.result[i].category_type_id == Config.category.drink) {
                        if (!mfoods[1]) {
                          mfoods[1] = [];
                        }
                        mfoods[1].push(tmpitem);
                      }
                      // other
                      else{
                        if (!mfoods[2]) {
                          mfoods[2] = [];
                        }
                        mfoods[2].push(tmpitem);
                      }
                    }
                  }

                  this.broadcaster.broadcast('loading.debug', "Menu reformed");
                  this.broadcaster.broadcast('loading.debug', "MenuGroup to load");
                  this._apiService.getMenuGroups().subscribe(
                    (result) => {
                      this.broadcaster.broadcast('loading.debug', "MenuGroup loaded");
                      if (result.status == 1000) {
                        this._okageStorage.setItem('menuGroup.mst', JSON.stringify(result.result));
                        this.broadcaster.broadcast('menuGroup.ready');
                        let mgrequires: any = {};
                        for (var i = 0; i < result.result.length; i++) {
                          if (!mgrequires[result.result[i].menu_id]) {
                            mgrequires[result.result[i].menu_id] = {};
                          }
                          mgrequires[result.result[i].menu_id][result.result[i].sub_menu_id]
                            = [
                              (result.result[i].required_flag == "1" ? true : false),
                              result.result[i].sort_order,
                              result.result[i].min,
                              result.result[i].max,
                            ]
                        }
                        // update required flag state from menu group
                        if (Object.keys(sfoods).length && Object.keys(mgrequires).length) {
                          for (var fk in sfoods) {
                            for (var i = 0; i < sfoods[fk].length; i++) {
                              if ('group_id' in sfoods[fk][i]) {
                                if (mgrequires[fk] && mgrequires[fk][sfoods[fk][i].group_id] !== 'undefined') {
                                  sfoods[fk][i].required = mgrequires[fk][sfoods[fk][i].group_id][0];
                                  sfoods[fk][i].group_order = parseInt(mgrequires[fk][sfoods[fk][i].group_id][1]);
                                  sfoods[fk][i].order = parseInt(mgrequires[sfoods[fk][i].group_id][sfoods[fk][i].id][1]);
                                  sfoods[fk][i].parent_min = mgrequires[fk][sfoods[fk][i].group_id][2];
                                  sfoods[fk][i].parent_max = mgrequires[fk][sfoods[fk][i].group_id][3];
                                }
                              } else {
                                if (mgrequires[fk] && mgrequires[fk][sfoods[fk][i].id] !== 'undefined') {
                                  sfoods[fk][i].required = mgrequires[fk][sfoods[fk][i].id][0];
                                  sfoods[fk][i].group_order = parseInt(mgrequires[fk][sfoods[fk][i].id][1]);
                                }
                              }
                            }
                            sfoods[fk] = sfoods[fk].sort((a, b) => {
                              if (a.order > a.order) {
                                return 1;
                              }
                              if (a.order < a.order) {
                                return -1;
                              }
                              if (a.group_order > b.group_order) {
                                return 1;
                              }
                              if (a.group_order < b.group_order) {
                                return -1;
                              }
                              return 0;
                            });

                            for (f in sfoods) {
                              let mgroup = [];
                              for (var fi = 0; fi < sfoods[f].length; fi++) {
                                if (!('group_name' in sfoods[f][fi])) {
                                  sfoods[f][fi].first = true;
                                } else {
                                  if (mgroup.indexOf(sfoods[f][fi].group_name) === -1) {
                                    sfoods[f][fi].first = true;
                                    mgroup.push(sfoods[f][fi].group_name);
                                  } else {
                                    sfoods[f][fi].first = false;
                                  }
                                }
                              }
                            }
                          }
                        }

                        var mgMst = JSON.parse(this._okageStorage.getItem("menuGroup.mst"));
                        var subSortMap = [];
                        for (let i=0; i<mgMst.length; i++){
                          subSortMap[mgMst[i].menu_id+"_"+mgMst[i].sub_menu_id] = mgMst[i].sort_order;
                        }
                        for (let mgid in sfoods){
                          for (let i=0; i<sfoods[mgid].length; i++){
                            var parentid = sfoods[mgid][i].parent;
                            var group_id = sfoods[mgid][i].group_id;
                            var m_id = sfoods[mgid][i].id;
                            if (subSortMap[group_id+"_"+m_id]){
                                sfoods[mgid][i].sort_order_in_group = parseInt(subSortMap[group_id+"_"+m_id], 0);
                            }
                            if (subSortMap[parentid+"_"+group_id]){
                                sfoods[mgid][i].sort_order = parseInt(subSortMap[parentid+"_"+group_id], 0);
                            }
                          }
                          sfoods[mgid].sort((a, b) => {
                            if (a.sort_order > b.sort_order) return 1;
                            if (a.sort_order < b.sort_order) return -1;
                            if (a.sort_order_in_group > b.sort_order_in_group) return 1;
                            if (a.sort_order_in_group < b.sort_order_in_group) return -1;
                          });
                        }

                        this.broadcaster.broadcast('loading.debug', "MenuGroup formed");
                        this.storage.set('foods.menu', mfoods).then(() => {
                          this._okageStorage.setItem('foods.submenu', JSON.stringify(sfoods));
                          this.broadcaster.broadcast('data.ready');
                          console.log("data all ready!!");
                          this.rootPage = TabsPage;
                        });
                        const storeConfigs = JSON.parse(localStorage.getItem('configs'));
                        if (storeConfigs["MOBILEORDER_REQUIRED_MENU_LIST"]) {
                          const requiredMenuList = JSON.parse(storeConfigs["MOBILEORDER_REQUIRED_MENU_LIST"]).required_menu_list;
                          requiredMenuList.forEach((r_menus, index) => {
                            if (r_menus.menubook_id && r_menus.menubook_id.some(menubook_id => { return menubook_id == localStorage.getItem("menubook_id"); })) {
                              let get_menus = Array();
                              r_menus.menus.forEach(r_menu => {
                                mfoods[2].find(m => {
                                  if (m.id === r_menu.menu_id) get_menus.push(m);
                                  if (m.id === r_menus.selected_menu_id) r_menus.selected_menu = m;
                                });
                              });
                              r_menus.menus = get_menus;
                              r_menus.selected_menu = (r_menus.selected_menu) ? r_menus.selected_menu : null;
                              r_menus.selected_menu_id = (r_menus.selected_menu_id) ? r_menus.selected_menu_id : null;
                            } else {
                              requiredMenuList.splice(index, 1);
                            }
                          });
                          this._okageStorage.setItem('requiredMenuList', requiredMenuList);
                        }
                        if (storeConfigs["MOBILEORDER_DELIVERY_CHARGE"]) {
                          const deliveryCharge = JSON.parse(storeConfigs["MOBILEORDER_DELIVERY_CHARGE"]).delivery_charge[0];
                          mfoods[2].find(m => {
                            if (deliveryCharge.charge_menu_id == m.id) {
                              deliveryCharge.charge_menu = m;
                              this._okageStorage.setItem('deliveryCharge', deliveryCharge);
                            }
                          });
                        }
                      } else {
                        // error
                      }
                    }
                  );
                },
                error => {
                  console.log('[api] getMenuList error: ' + error);
                });
            } else {
              this.rootPage = ErrorPage;
            }
          }
        );
      } else {
        this.broadcaster.broadcast('menulayouts.ready');
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    //this.nav.setRoot(page.component);
    this.nav.setRoot(page,{},{animate: true, direction: "forward"});
    this.nav.push(page,{},{animate: true, direction: "forward"});
  }

  getUrlParameter(name: string) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? results : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // 受け取り方法の選択モーダル
  selectReceiveModal(config: any) {
    // 受け取り方法の値を取得し、localStorageにSETする
    let configReceiveMethod = config['MOBILEORDER_RECEIVE_METHOD'];
    if (!configReceiveMethod || (this._okageStorage.getItem("reserved_dates") != "")) { // 何も設定されていない場合 & 予約注文の場合
      localStorage.setItem("receiveMethod", 'takeout');
    } else if (configReceiveMethod.includes('receive_methods')) { // jsonの値かどうか
      let jsonReceiveMethod = JSON.parse(configReceiveMethod);

      // jsonの要素が複数あるならモーダルを表示
      if (Object.keys(jsonReceiveMethod['receive_methods']).length > 1) {
        let receiveTypes = [];
        jsonReceiveMethod.receive_methods.map(function(module) {
          receiveTypes.push(module['type']);
        })
        let modal = this.modalCtrl.create(SelectReceiveModalComponent, { title: this._loc.t('受け取り方法を選択してください'), isReceivingMethod: true, receiveTypes: receiveTypes }, { showBackdrop: false, enableBackdropDismiss: false });
        modal.onDidDismiss(type => {
          localStorage.setItem('receiveMethod', type);
          if (type === 'delivery') {
            // 配送料のメニューID取得
            localStorage.setItem("chargeId", config['MOBILEORDER_DELIVERY_CHARGE_MENU_ID']);
          }
        })
        modal.present();
      } else { // 単数なら値をそのままset
        localStorage.setItem("receiveMethod", jsonReceiveMethod['receive_methods'][0]['type']);
      }
    } else { // string
      localStorage.setItem("receiveMethod", configReceiveMethod);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts